import { Textarea } from '@components/Textarea';
import { TaskAttributes } from 'chaika-test-attributes';
import { translate } from '@chaika/i18n/helper';

interface Props {
    value?: string;
    onChange(e: React.ChangeEvent<HTMLTextAreaElement>): void;
}

export function TaskRejectionCommentInput({ value, onChange }: Props): React.ReactElement<any> {
    return (
        <Textarea
            dataTest={TaskAttributes.RejectionComment}
            placeholder={translate('mustCompletedForReject')}
            title={translate('executorsComment')}
            value={value ?? ''}
            name={'rejectionComment'}
            onChange={onChange}
        />
    );
}
